import React, { useState, useEffect } from 'react';
import SearchFieldsSelect, { useSearchFields, getSearchFieldsPlaceholder } from '../../Components/SearchFieldsSelect/SearchFieldsSelect';
import { Table, Button, Avatar, Tag, Typography, Input, Select, DatePicker, Space, Row, Col, Card, Tooltip, Badge, message, Pagination, Statistic, Modal, Divider, InputNumber } from 'antd';
import { 
  UserOutlined, 
  MailOutlined, 
  PhoneOutlined, 
  CarOutlined, 
  TagOutlined, 
  EyeOutlined,
  SearchOutlined,
  ReloadOutlined,
  FilterOutlined,
  CalendarOutlined,
  DollarOutlined,
  ClockCircleOutlined,
  CheckOutlined,
  CloseOutlined,
  FileDoneOutlined,
  FileTextOutlined,
  ShoppingCartOutlined,
  SyncOutlined,
  StopOutlined,
  EditOutlined,
  SaveOutlined,
  CopyOutlined,
  ClearOutlined,
  TeamOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  WalletOutlined,
  ExclamationCircleOutlined,
  PercentageOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,CommentOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import API from '../../API/API';
import dayjs from 'dayjs';
import { motion } from 'framer-motion';

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);

const { Text, Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;
const toPST = (date) => {
    if (!date) return null;
    return dayjs(date).tz('America/Los_Angeles');
};

const CustomerRefund = () => {
  const navigate = useNavigate();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  
  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(24);
  const [totalRecords, setTotalRecords] = useState(0);
  
  // Agent filter state
  const [agents, setAgents] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState(null);
  const [loginAgent, setLoginAgent] = useState({});
  
  // Editing states
  const [editingId, setEditingId] = useState(null);
  const [editingField, setEditingField] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const [serviceAgentsMap, setServiceAgentsMap] = useState({});
const [loadingServiceAgents, setLoadingServiceAgents] = useState(false);
const [selectedServiceAgentId, setSelectedServiceAgentId] = useState(null);
// Add these with your other state declarations
const [serviceAgentModalVisible, setServiceAgentModalVisible] = useState(false);
const [selectedLeadForServiceAgent, setSelectedLeadForServiceAgent] = useState(null);
const [selectedServiceAgentForLead, setSelectedServiceAgentForLead] = useState(null);
const [savingServiceAgent, setSavingServiceAgent] = useState(false);
  const [sortedInfo, setSortedInfo] = useState({
    field: 'updatedAt',
    order: 'descend',
  });
  const [filteredInfo, setFilteredInfo] = useState({
    part: null,
    zohoStatus: null,
    invoiceStatus: null,
    purchaseOrderStatus: null,
    agent: null,
  });
  // Add these near your other state declarations
const [editingCustomerRefundId, setEditingCustomerRefundId] = useState(null);
const [editingCustomerRefundData, setEditingCustomerRefundData] = useState({
  customerChargedAmount: 0,
  refundAmount: 0,
  restockingFee: 0,
  customerRefundStatus: "No"
});
const [savingCustomerRefund, setSavingCustomerRefund] = useState(false);
  // Search and filter states
  const [searchText, setSearchText] = useState('');
  // The search a request uses: the box's text, set 0.5 s after typing pauses
  // (at once when the box is cleared), so a search is not sent per keystroke.
  const [searchQuery, setSearchQuery] = useState('');
  useEffect(() => {
    const trimmed = searchText.trim();
    if (!trimmed) {
      setSearchQuery('');
      return undefined;
    }
    const timer = setTimeout(() => setSearchQuery(trimmed), 500);
    return () => clearTimeout(timer);
  }, [searchText]);
  const [searchFields, setSearchFields] = useSearchFields('customer-refund:search-fields');
  // The "Search in" group only changes the results of a search, so changing it
  // with an empty search box sends no request.
  const effectiveSearchFields = searchQuery ? searchFields : null;
  const [dateRange, setDateRange] = useState(() => {
    const now = dayjs();
    return [now.startOf('month'), now.endOf('month')];
  });
  const [quickDateFilter, setQuickDateFilter] = useState('thisMonth');
  const [commentsModalVisible, setCommentsModalVisible] = useState(false);
      const [selectedLeadForComment, setSelectedLeadForComment] = useState(null);
      const [newComment, setNewComment] = useState('');
      const [addingComment, setAddingComment] = useState(false);
  const [selectedServiceAgentField, setSelectedServiceAgentField] = useState('serviceHandledBy');

  // Statistics
  const [statistics, setStatistics] = useState({
    totalPending: 0,
    totalAmount: 0,
    averageAmount: 0,
    refundedCount: 0,
    totalRefundAmount: 0,
  });

  const isAdmin = loginAgent?.role === "ADMIN";

  // Status options based on schema
  const zohoStatusOptions = [
    'SENT',
    'NOT-SENT',
    'RECEIVED',
    'DL-COPY',
    'EMAIL-APPROVAL',
    'COMPLETED', 
    'INCOMPLETE',
    'FAILED',
  ];

  const invoiceStatusOptions = [
    'INVOICE-SENT',
    'INVOICE-NOT-SENT'
  ];

  const purchaseOrderStatusOptions = [
    'PO-SENT',
    'PO-NOT-SENT',
    'PO-CONFIRMED',
    'PO-NOT-CONFIRMED'
  ];
const [editingSpecification, setEditingSpecification] = useState(null);
const [editingSpecValue, setEditingSpecValue] = useState('');
const [updatingSpecification, setUpdatingSpecification] = useState(false);
 

const handleUpdateSpecification = async (leadId, newSpecification) => {
    if (!leadId) return;
    
    const trimmedValue = newSpecification?.trim() || '';
    
    if (trimmedValue.length > 2000) {
        message.warning('Specification cannot exceed 2000 characters');
        return;
    }
    
    setUpdatingSpecification(true);
    try {
        // First, get the current lead data to preserve other vehicleInfo fields
        const currentLead = leads.find(lead => lead._id === leadId);
        const currentVehicleInfo = currentLead?.vehicleInfo || {};
        
        // Merge the specification with existing vehicleInfo
        const payload = {
            vehicleInfo: {
                ...currentVehicleInfo, // Preserve all existing fields
                specification: trimmedValue // Update only specification
            }
        };
        
        console.log('Sending payload with preserved data:', payload);
        
        const response = await API.UpdateLead(leadId, payload);
        
        if (response?.status) {
            message.success('Specification updated successfully!');
            fetchLeads(); // Refresh the leads list
        } else {
            message.error(response?.message || 'Failed to update specification');
        }
    } catch (error) {
        console.error('Error updating specification:', error);
        message.error('Failed to update specification');
    } finally {
        setUpdatingSpecification(false);
        setEditingSpecification(null);
        setEditingSpecValue('');
    }
};
  // Get user data on mount
  useEffect(() => {
    const UD = localStorage.getItem('userData');
    if (!UD) {
      navigate(ROUTES?.LOGIN);
      return;
    }
    const parsedUser = JSON.parse(UD);
    setLoginAgent(parsedUser);
    
    if (parsedUser?.role === "ADMIN") {
      fetchAgents();
    }
       fetchServiceAgents();

  }, [navigate]);

  // Add these functions with your other handler functions
const handleEditCustomerRefundStart = (record) => {
  const refund = record.customerRefund || {};
  setEditingCustomerRefundId(record._id);
  setEditingCustomerRefundData({
    customerChargedAmount: refund.customerChargedAmount || record.totalAmount || 0,
    refundAmount: refund.refundAmount || 0,
    restockingFee: refund.restockingFee || 0,
    customerRefundStatus: refund.customerRefundStatus || "No"
  });
};

const handleEditCustomerRefundCancel = () => {
  setEditingCustomerRefundId(null);
  setEditingCustomerRefundData({
    customerChargedAmount: 0,
    refundAmount: 0,
    restockingFee: 0,
    customerRefundStatus: "No"
  });
};

const handleEditCustomerRefundSave = async (record) => {
  setSavingCustomerRefund(true);
  try {
    const payload = {
      customerRefund: {
        customerChargedAmount: editingCustomerRefundData.customerChargedAmount,
        refundAmount: editingCustomerRefundData.refundAmount,
        restockingFee: editingCustomerRefundData.restockingFee,
        customerRefundStatus: editingCustomerRefundData.customerRefundStatus,
        updatedDate: new Date().toISOString()
      }
    };

    const response = await API.UpdateLead(record._id, payload);
    
    if (response.status) {
      message.success('Customer refund updated successfully');
      setEditingCustomerRefundId(null);
      fetchLeads(); // Refresh the list
    } else {
      message.error(response.message || 'Failed to update');
    }
  } catch (error) {
    console.error('Error updating customer refund:', error);
    message.error('Failed to update customer refund');
  } finally {
    setSavingCustomerRefund(false);
  }
};
// Handle opening the service agent selection modal with field type parameter
const handleServiceAgentEdit = (record, fieldType = 'serviceHandledBy') => {
    let currentServiceAgentId;
    switch(fieldType) {
        case 'orderServiceHandledBy':
            currentServiceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
            break;
        case 'zohoServiceHandledBy':
            currentServiceAgentId = record.zohoServiceHandledBy?._id || record.zohoServiceHandledBy;
            break;
        case 'yardServiceHandledBy':
            currentServiceAgentId = record.yardServiceHandledBy?._id || record.yardServiceHandledBy;
            break;
        default:
            currentServiceAgentId = record.serviceHandledBy?._id || record.serviceHandledBy;
    }
    setSelectedLeadForServiceAgent(record);
    setSelectedServiceAgentForLead(currentServiceAgentId || null);
    setSelectedServiceAgentField(fieldType); // Add this line
    setServiceAgentModalVisible(true);
};

// Handle saving the service agent with field type parameter
const handleServiceAgentSave = async (fieldType = 'serviceHandledBy') => {
    if (!selectedLeadForServiceAgent) return;
    
    setSavingServiceAgent(true);
    
    try {
        const payload = {
            [fieldType]: selectedServiceAgentForLead || null
        };
        
        const response = await API.UpdateLead(selectedLeadForServiceAgent._id, payload);
        
        if (response?.status || response?.success) {
            message.success('Service agent assigned successfully!');
            
            setLeads(prevLeads => 
                prevLeads.map(lead => 
                    lead._id === selectedLeadForServiceAgent._id ? { 
                        ...lead, 
                        [fieldType]: selectedServiceAgentForLead
                    } : lead
                )
            );
            
            setServiceAgentModalVisible(false);
            setSelectedLeadForServiceAgent(null);
            setSelectedServiceAgentForLead(null);
            fetchLeads(true);
            fetchServiceAgents();
        } else {
            message.error(response?.message || 'Failed to assign service agent');
        }
    } catch (error) {
        console.error('Error assigning service agent:', error);
        message.error('Failed to save service agent assignment');
    } finally {
        setSavingServiceAgent(false);
    }
};
    const handleAddComment = async () => {
      if (!newComment.trim()) {
          message.warning('Please enter a comment');
          return;
      }
  
      if (!selectedLeadForComment) return;
  
      setAddingComment(true);
      try {
          const existingComments = selectedLeadForComment.customerRefundPageComment || [];
          const payload = {
              customerRefundPageComment: [
                  ...existingComments,
                  {
                      comment: newComment.trim(),
                      changedAt: new Date().toISOString()
                  }
              ]
          };
  
          const response = await API.UpdateLead(selectedLeadForComment._id, payload);
  
          if (response?.status) {
              message.success('Comment added successfully!');
              setNewComment('');
              setCommentsModalVisible(false);
              setSelectedLeadForComment(null);
              // Refresh the leads list
              fetchLeads();
          } else {
              message.error(response?.message || 'Failed to add comment');
          }
      } catch (error) {
          console.error('Error adding comment:', error);
          message.error('Failed to add comment');
      } finally {
          setAddingComment(false);
      }
  };
  
  const formatCommentDate = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit"
      });
  };

// Get Service Agent Name (serviceHandledBy) - already exists
const getServiceAgentName = (record) => {
    const serviceAgentId = record.serviceHandledBy?._id || record.serviceHandledBy;
    if (!serviceAgentId) return null;
    
    if (record.serviceHandledBy && typeof record.serviceHandledBy === 'object') {
        return `${record.serviceHandledBy.firstName || ''} ${record.serviceHandledBy.lastName || ''}`.trim() || 
               record.serviceHandledBy.userName || 'Service Agent';
    }
    
    const agentInfo = serviceAgentsMap[serviceAgentId];
    return agentInfo?.name || null;
};

// Get Order Service Agent Name (orderServiceHandledBy)
const getOrderServiceAgentName = (record) => {
    const orderServiceAgentId = record.orderServiceHandledBy?._id || record.orderServiceHandledBy;
    if (!orderServiceAgentId) return null;
    
    if (record.orderServiceHandledBy && typeof record.orderServiceHandledBy === 'object') {
        return `${record.orderServiceHandledBy.firstName || ''} ${record.orderServiceHandledBy.lastName || ''}`.trim() || 
               record.orderServiceHandledBy.userName || 'Order Service Agent';
    }
    
    const agentInfo = serviceAgentsMap[orderServiceAgentId];
    return agentInfo?.name || null;
};

// Get Zoho Service Agent Name (zohoServiceHandledBy)
const getZohoServiceAgentName = (record) => {
    const zohoServiceAgentId = record.zohoServiceHandledBy?._id || record.zohoServiceHandledBy;
    if (!zohoServiceAgentId) return null;
    
    if (record.zohoServiceHandledBy && typeof record.zohoServiceHandledBy === 'object') {
        return `${record.zohoServiceHandledBy.firstName || ''} ${record.zohoServiceHandledBy.lastName || ''}`.trim() || 
               record.zohoServiceHandledBy.userName || 'Zoho Service Agent';
    }
    
    const agentInfo = serviceAgentsMap[zohoServiceAgentId];
    return agentInfo?.name || null;
};

// Get Yard Service Agent Name (yardServiceHandledBy)
const getYardServiceAgentName = (record) => {
    const yardServiceAgentId = record.yardServiceHandledBy?._id || record.yardServiceHandledBy;
    if (!yardServiceAgentId) return null;
    
    if (record.yardServiceHandledBy && typeof record.yardServiceHandledBy === 'object') {
        return `${record.yardServiceHandledBy.firstName || ''} ${record.yardServiceHandledBy.lastName || ''}`.trim() || 
               record.yardServiceHandledBy.userName || 'Yard Service Agent';
    }
    
    const agentInfo = serviceAgentsMap[yardServiceAgentId];
    return agentInfo?.name || null;
};

const fetchServiceAgents = async () => {
    setLoadingServiceAgents(true);
    try {
        const response = await API.userGetAll();
        if (response?.success) {
            const agentsMap = {};
            // Get all users with SERVICE-AGENT or SUPPORT-AGENT role
            const serviceAgentsList = (response.data || []).filter(
                user => user.role === "SERVICE-AGENT" || user.role === "SUPPORT-AGENT"
            );
            serviceAgentsList.forEach(agent => {
                agentsMap[agent._id] = {
                    name: `${agent.firstName || ''} ${agent.lastName || ''}`.trim() || agent.userName || agent.email,
                    email: agent.email,
                    phone: agent.directNumber,
                    role: agent.role
                };
            });
            setServiceAgentsMap(agentsMap);
        }
    } catch (error) {
        console.error("Failed to fetch service agents", error);
    } finally {
        setLoadingServiceAgents(false);
    }
};
  const fetchAgents = async () => {
    try {
      const response = await API.userGetAll();
      if (response?.success) {
        const salesAgents = (response.data || []).filter(user => user.role === "SALES-AGENT");
        setAgents(salesAgents);
      }
    } catch (error) {
      console.error("Failed to fetch agents", error);
    }
  };

  // Get agent name function
  const getAgentName = (record) => {
    if (record.assignedAgent?.name) return record.assignedAgent.name;
    if (record.agentName) return record.agentName;
    if (record.handledBy?.firstName && record.handledBy?.lastName) {
      return `${record.handledBy.firstName} ${record.handledBy.lastName}`;
    }
    if (record.handledBy?.name) return record.handledBy.name;
    return 'Unassigned';
  };

  // Get unique agents for filter
  const getUniqueAgents = () => {
    const agentNames = leads
      .map(lead => getAgentName(lead))
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return agentNames;
  };

  // Get unique values for filters
  const getUniqueValues = (field) => {
    const values = leads
      .map(lead => {
        if (field === 'part') return lead.vehicleInfo?.part;
        if (field === 'zohoStatus') return lead.zohoStatus;
        if (field === 'invoiceStatus') return lead.invoiceStatus;
        if (field === 'purchaseOrderStatus') return lead.purchaseOrderStatus;
        return lead[field];
      })
      .filter((value, index, self) => value && self.indexOf(value) === index);
    return values;
  };

  // Calculate statistics
  const calculateStatistics = (data) => {
    const totalPending = data.length;
    const totalAmount = data.reduce((sum, lead) => sum + (lead.totalAmount || 0), 0);
    const averageAmount = totalPending > 0 ? totalAmount / totalPending : 0;
    const refundedCount = data.filter(lead => lead.customerRefund?.customerRefundStatus === 'Yes').length;
    const totalRefundAmount = data.reduce((sum, lead) => sum + (lead.customerRefund?.refundAmount || 0), 0);
    
    setStatistics({
      totalPending,
      totalAmount,
      averageAmount,
      refundedCount,
      totalRefundAmount,
    });
  };

  // Get date range based on quick filter
  const getQuickDateRange = (filterType) => {
    const now = dayjs();
    let startDate = now;
    let endDate = now;

    switch (filterType) {
      case 'today':
        startDate = now.startOf('day');
        endDate = now.endOf('day');
        break;
      case 'yesterday':
        startDate = now.subtract(1, 'day').startOf('day');
        endDate = now.subtract(1, 'day').endOf('day');
        break;
      case 'thisWeek':
        startDate = now.startOf('week');
        endDate = now.endOf('week');
        break;
      case 'thisMonth':
        startDate = now.startOf('month');
        endDate = now.endOf('month');
        break;
      case 'lastMonth':
        startDate = now.subtract(1, 'month').startOf('month');
        endDate = now.subtract(1, 'month').endOf('month');
        break;
      case 'thisQuarter':
        startDate = now.startOf('quarter');
        endDate = now.endOf('quarter');
        break;
      case 'thisYear':
        startDate = now.startOf('year');
        endDate = now.endOf('year');
        break;
      default:
        return null;
    }

    return [startDate, endDate];
  };

  // Set default date range to current month on component mount
  useEffect(() => {
    const defaultDateRange = getQuickDateRange('thisMonth');
    setDateRange(defaultDateRange);
  }, []);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, effectiveSearchFields, dateRange, filteredInfo, sortedInfo.field, sortedInfo.order, selectedAgentId]);

  // Handle quick date filter change
  const handleQuickDateFilter = (value) => {
    setQuickDateFilter(value);
    const newDateRange = getQuickDateRange(value);
    setDateRange(newDateRange);
    setCurrentPage(1);
  };
const fetchLeads = async (isRefresh = false) => {
  if (isRefresh) {
    setRefreshing(true);
  } else {
    setLoading(true);
  }
  
  try {
    const isSearching = Boolean(searchQuery);
    const params = {
      page: currentPage,
      limit: pageSize,
      sortBy: sortedInfo.field || 'updatedAt',
      order: sortedInfo.order === 'ascend' ? 'asc' : 'desc',
      orderProcessComplete: {
        partStatus: 'Customer Canceled',
        explicitCanceledOnly: true
      }
    };
params.customerRefundStatus = "No";
    if (isSearching) {
      params.search = searchQuery;
      params.searchFields = searchFields;
    } else {
      params.dateField = 'updatedAt';

      if (dateRange && dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].startOf('day').toISOString();
        params.endDate = dateRange[1].endOf('day').toISOString();
      } else {
        // Default to this month if dateRange is null
        const now = dayjs();
        params.startDate = now.startOf('month').toISOString();
        params.endDate = now.endOf('month').toISOString();
      }
    
    }

    if (filteredInfo.part) {
      params.part = filteredInfo.part.join(',');
    }

    if (filteredInfo.zohoStatus) {
      params.zohoStatus = filteredInfo.zohoStatus.join(',');
    }

    if (filteredInfo.invoiceStatus) {
      params.invoiceStatus = filteredInfo.invoiceStatus.join(',');
    }

    if (filteredInfo.purchaseOrderStatus) {
      params.purchaseOrderStatus = filteredInfo.purchaseOrderStatus.join(',');
    }

    // Add agent filter for admin
    if (isAdmin && selectedAgentId) {
      params.agentId = selectedAgentId;
    }

    // Refund page membership is now backend-filtered by explicit Order Process cancellation.
    
    // The server sends only the fields this page uses
    // (LeadController LEAD_VIEW_FIELDS['customer-refund']).
    params.view = 'customer-refund';
    const response = await API.leadGetAll(params);
    
    if (response.status && response.data) {
      setLeads(response.data);
      calculateStatistics(response.data);
      const possibleTotal = response.pagination?.totalRecords || 
                            response.total || 
                            response.totalRecords ||
                            response.data.length;
      setTotalRecords(possibleTotal);
      
      if (!isSearching && response.data.length === 0 && dateRange && dateRange[0] && dateRange[1]) {
        message.info(`No leads found matching the criteria in selected date range`);
      }
      
    } else {
      setLeads([]);
      setTotalRecords(0);
    }
  } catch (error) {
    console.error('Error fetching leads:', error);
    message.error('Failed to fetch leads');
    setLeads([]);
    setTotalRecords(0);
  } finally {
    setLoading(false);
    setRefreshing(false);
  }
};

  // Handle refresh
  const handleRefresh = () => {
    fetchLeads(true);
  };

  // Handle search
  const handleSearch = (value) => {
    setSearchText(value);
  };

 // Update the handleDateRangeChange function
const handleDateRangeChange = (dates) => {
  if (!dates || !dates[0] || !dates[1]) {
    // Reset to this month when cancelled
    const defaultDateRange = getQuickDateRange('thisMonth');
    setDateRange(defaultDateRange);
    setQuickDateFilter('thisMonth');
    message.info('Date range reset to this month');
  } else {
    setDateRange(dates);
    setQuickDateFilter('custom');
  }
  setCurrentPage(1);
};

// Add a useEffect to handle dateRange changes and refetch leads
useEffect(() => {
  if (dateRange && dateRange[0] && dateRange[1]) {
    fetchLeads();
  }
}, [dateRange]); // Add this dependency

  // Handle clear filters
const clearAllFilters = () => {
  setSearchText('');
  const defaultDateRange = getQuickDateRange('thisMonth');
  setDateRange(defaultDateRange);
  setQuickDateFilter('thisMonth');
  setFilteredInfo({ part: null, zohoStatus: null, invoiceStatus: null, purchaseOrderStatus: null, agent: null });
  setSelectedAgentId(null);
  setSortedInfo({ field: 'updatedAt', order: 'descend' });
  setCurrentPage(1);
  message.info({
    content: "All filters cleared, date reset to this month",
    icon: <ClearOutlined />
  });
};

  // Handle view button click
  const handleView = (record) => {
    setSelectedLeadId(record._id);
    navigate(`/lead-details/${record._id}`);
  };

  // Handle table change
  const handleTableChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  // Handle pagination change
  const handlePaginationChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
  };

  // Handle edit start
  const handleEditStart = (record, field) => {
    setEditingId(record._id);
    setEditingField(field);
    setEditingValue(record[field] || '');
  };

  // Handle edit cancel
  const handleEditCancel = () => {
    setEditingId(null);
    setEditingField(null);
    setEditingValue('');
  };

  // Handle edit save
  const handleEditSave = async (id) => {
    try {
      const updateData = {};
      updateData[editingField] = editingValue;

      const response = await API.UpdateLead(id, updateData);
      
      if (response.status) {
        message.success(`${editingField} updated successfully`);
        setLeads(prevLeads => 
          prevLeads.map(lead => 
            lead._id === id ? { ...lead, [editingField]: editingValue } : lead
          )
        );
        setEditingId(null);
        setEditingField(null);
        setEditingValue('');
        calculateStatistics(leads);
      } else {
        message.error('Failed to update status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      message.error('Error updating status');
    }
  };

  // Load leads on mount and when dependencies change
  useEffect(() => {
    fetchLeads();
  }, [
    currentPage, 
    pageSize, 
    sortedInfo.field, 
    sortedInfo.order, 
    filteredInfo.part,
    filteredInfo.zohoStatus,
    filteredInfo.invoiceStatus,
    filteredInfo.purchaseOrderStatus,
    searchQuery,
    effectiveSearchFields,
    dateRange,
    selectedAgentId,
    selectedServiceAgentId
  ]);

  // Status color mapping
  const getStatusConfig = (status, type) => {
    const configs = {
      zoho: {
        'SENT': { color: '#1890ff', icon: <SyncOutlined />, text: 'SENT' },
        'NOT-SENT': { color: '#bfbfbf', icon: <CloseOutlined />, text: 'NOT SENT' },
        'COMPLETED': { color: '#52c41a', icon: <CheckOutlined />, text: 'COMPLETED' },
        'INCOMPLETE': { color: '#faad14', icon: <StopOutlined />, text: 'INCOMPLETE' },
        'FAILED': { color: '#ff4d4f', icon: <CloseOutlined />, text: 'FAILED' },
        'RECEIVED': { color: '#722ed1', icon: <FileDoneOutlined />, text: 'RECEIVED' },
        'DL-COPY': { color: '#13c2c2', icon: <FileTextOutlined />, text: 'DL COPY' },
        'EMAIL-APPROVAL': { color: '#eb2f96', icon: <MailOutlined />, text: 'EMAIL APPROVAL' },
        'default': { color: '#bfbfbf', icon: <FileDoneOutlined />, text: 'NOT-SENT' }
      },
      invoice: {
        'INVOICE-SENT': { color: '#52c41a', icon: <CheckOutlined />, text: 'INVOICE SENT' },
        'INVOICE-NOT-SENT': { color: '#bfbfbf', icon: <CloseOutlined />, text: 'NOT SENT' },
        'default': { color: '#bfbfbf', icon: <FileTextOutlined />, text: 'NOT SENT' }
      },
      po: {
        'PO-SENT': { color: '#52c41a', icon: <CheckOutlined />, text: 'PO SENT' },
        'PO-NOT-SENT': { color: '#bfbfbf', icon: <CloseOutlined />, text: 'NOT SENT' },
        'PO-CONFIRMED': { color: '#1890ff', icon: <CheckOutlined />, text: 'CONFIRMED' },
        'PO-NOT-CONFIRMED': { color: '#faad14', icon: <StopOutlined />, text: 'NOT CONFIRMED' },
        'default': { color: '#bfbfbf', icon: <ShoppingCartOutlined />, text: 'NOT SENT' }
      }
    };

    return configs[type]?.[status] || configs[type]?.default;
  };

  // Render editable cell
  const renderEditableCell = (record, field, options, type) => {
    const isEditing = editingId === record._id && editingField === field;
    
    if (isEditing) {
      return (
        <Space size={4} direction="vertical" style={{ width: '100%' }}>
          <Select
            value={editingValue}
            onChange={setEditingValue}
            style={{ width: '100%' }}
            size="small"
            showSearch
            optionFilterProp="children"
          >
            {options.map(option => (
              <Option key={option} value={option}>{option.replace(/-/g, ' ')}</Option>
            ))}
          </Select>
          <Space size={4}>
            <Button 
              type="primary" 
              size="small" 
              icon={<SaveOutlined />} 
              onClick={() => handleEditSave(record._id)}
              style={{ flex: 1, borderRadius: 6 }}
            />
            <Button 
              size="small" 
              icon={<CloseOutlined />} 
              onClick={handleEditCancel}
              style={{ borderRadius: 6 }}
            />
          </Space>
        </Space>
      );
    }

    const config = getStatusConfig(record[field], type);
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Tag 
          icon={config.icon}
          color={config.color}
          style={{ 
            padding: '4px 12px', 
            borderRadius: 16,
            fontSize: 12,
            fontWeight: 500,
            cursor: 'pointer',
            margin: 0
          }}
          onClick={() => handleEditStart(record, field)}
        >
          {config.text}
        </Tag>
        <Tooltip title="Edit">
          <Button 
            type="text" 
            size="small" 
            icon={<EditOutlined />} 
            onClick={() => handleEditStart(record, field)}
            style={{ color: '#1890ff' }}
          />
        </Tooltip>
      </div>
    );
  };

  const isSearching = searchText?.trim().length > 0;

  // Agent column definition
  const agentColumn = isAdmin ? [{
    title: 'Sales-Agent',
    key: 'agent',
    width: 160,
    sorter: (a, b) => getAgentName(a).localeCompare(getAgentName(b)),
    filters: getUniqueAgents().map(value => ({ text: value, value })),
    filteredValue: filteredInfo.agent || null,
    render: (_, record) => {
      const agentName = getAgentName(record);
      const isUnassigned = agentName === 'Unassigned';
      return (
        <Tooltip title={agentName}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Avatar
              size={32}
              icon={<UserOutlined />}
              style={{
                backgroundColor: isUnassigned ? '#d9d9d9' : '#722ed1',
                flexShrink: 0,
              }}
            >
              {!isUnassigned && agentName?.[0]?.toUpperCase()}
            </Avatar>
            <Text
              ellipsis={{ tooltip: true }}
              style={{
                fontSize: 13,
                color: isUnassigned ? '#8c8c8c' : '#1f2937',
                fontStyle: isUnassigned ? 'italic' : 'normal',
              }}
            >
              {agentName}
            </Text>
          </div>
        </Tooltip>
      );
    },
  }] : [];

  // Table columns
  const columns = [
        {
          title: "Order Number",
          width: 120, // Slightly increased width to accommodate date
          key: "orderNumber",
          render: (_, record) => {
            const hasOrderNumber = record.orderNumber;
            
            return (
              <div>
                {/* Order Number Section */}
                <div style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  background: hasOrderNumber ? '#f0f0ff' : '#fff1f0',
                  padding: '4px 8px',
                  borderRadius: 8,
                  width: 'fit-content'
                }}>
                  {hasOrderNumber ? (
                    <FileTextOutlined style={{ color: '#722ed1', fontSize: 12 }} />
                  ) : (
                    <ClockCircleOutlined style={{ color: '#ff4d4f', fontSize: 12 }} />
                  )}
                  <Text style={{ 
                    color: hasOrderNumber ? '#722ed1' : '#ff4d4f',
                    fontSize: 12,
                    fontWeight: 600,
                    fontFamily: 'monospace',
                    fontStyle: hasOrderNumber ? 'normal' : 'italic'
                  }}>
                    {hasOrderNumber ? `#${record.orderNumber.slice(-8)}` : 'Waiting..'}
                  </Text>
                  {hasOrderNumber && (
                    <Tooltip title="Copy Order Number">
                      <Button
                        type="text"
                        size="small"
                        icon={<CopyOutlined style={{ fontSize: 10 }} />}
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(record.orderNumber);
                          message.success('Order number copied!');
                        }}
                        style={{
                          padding: 0,
                          height: 18,
                          width: 18,
                          minWidth: 18,
                          color: '#722ed1',
                        }}
                      />
                    </Tooltip>
                  )}
                </div>
                
                {/* Date Section - Shows Order Date or Created Date */}
                {(record.orderDate || record.createdAt) && (
                  <div style={{ 
                    marginTop: 6,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    paddingLeft: 4
                  }}>
                    <CalendarOutlined style={{ fontSize: 10, color: '#8c8c8c' }} />
                    <Tooltip 
                      title={dayjs(record.orderDate || record.createdAt).format('MMM DD, YYYY hh:mm A')}
                    >
                      <Text type="secondary" style={{ fontSize: 10 }}>
                        {record.orderDate 
                          ? dayjs(record.orderDate).format('MM/DD/YY hh:mm A')
                          : ` ${dayjs(record.createdAt).format('MM/DD/YY hh:mm A')}`
                        }
                      </Text>
                    </Tooltip>
                  </div>
                )}
              </div>
            );
          }
        },
    ...agentColumn,
 // SERVICE AGENT 1: serviceHandledBy
{
    title: 'Shipping Service-Agent',
    key: 'serviceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getServiceAgentName(a) || '';
        const nameB = getServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const agentName = getServiceAgentName(record);
        const isAssigned = !!agentName;
        
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleServiceAgentEdit(record, 'serviceHandledBy')}>
                <Tooltip title={isAssigned ? `Click to change service agent` : 'Click to assign service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar size={32} icon={<TeamOutlined />} style={{ backgroundColor: isAssigned ? '#52c41a' : '#f0f0f0', flexShrink: 0 }}>
                            {isAssigned && agentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text ellipsis={{ tooltip: true }} style={{ fontSize: 13, color: '#1f2937', display: 'block', fontWeight: 500 }}>
                                        {agentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>Click to edit</Text>
                                </>
                            ) : (
                                <Text style={{ fontSize: 13, color: '#1890ff', fontStyle: 'italic' }}>+ Assign Agent</Text>
                            )}
                        </div>
                        <EditOutlined style={{ fontSize: 12, color: '#1890ff', opacity: 0.6 }} />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
// SERVICE AGENT 2: orderServiceHandledBy
{
    title: 'Order Service-Agent',
    key: 'orderServiceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getOrderServiceAgentName(a) || '';
        const nameB = getOrderServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const agentName = getOrderServiceAgentName(record);
        const isAssigned = !!agentName;
        
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleServiceAgentEdit(record, 'orderServiceHandledBy')}>
                <Tooltip title={isAssigned ? `Click to change order service agent` : 'Click to assign order service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar size={32} icon={<TeamOutlined />} style={{ backgroundColor: isAssigned ? '#1890ff' : '#f0f0f0', flexShrink: 0 }}>
                            {isAssigned && agentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text ellipsis={{ tooltip: true }} style={{ fontSize: 13, color: '#1f2937', display: 'block', fontWeight: 500 }}>
                                        {agentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>Click to edit</Text>
                                </>
                            ) : (
                                <Text style={{ fontSize: 13, color: '#1890ff', fontStyle: 'italic' }}>+ Assign Agent</Text>
                            )}
                        </div>
                        <EditOutlined style={{ fontSize: 12, color: '#1890ff', opacity: 0.6 }} />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
// SERVICE AGENT 3: zohoServiceHandledBy
{
    title: 'Doc Service-Agent',
    key: 'zohoServiceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getZohoServiceAgentName(a) || '';
        const nameB = getZohoServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const agentName = getZohoServiceAgentName(record);
        const isAssigned = !!agentName;
        
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleServiceAgentEdit(record, 'zohoServiceHandledBy')}>
                <Tooltip title={isAssigned ? `Click to change Zoho service agent` : 'Click to assign Zoho service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar size={32} icon={<TeamOutlined />} style={{ backgroundColor: isAssigned ? '#faad14' : '#f0f0f0', flexShrink: 0 }}>
                            {isAssigned && agentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text ellipsis={{ tooltip: true }} style={{ fontSize: 13, color: '#1f2937', display: 'block', fontWeight: 500 }}>
                                        {agentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>Click to edit</Text>
                                </>
                            ) : (
                                <Text style={{ fontSize: 13, color: '#1890ff', fontStyle: 'italic' }}>+ Assign Agent</Text>
                            )}
                        </div>
                        <EditOutlined style={{ fontSize: 12, color: '#1890ff', opacity: 0.6 }} />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
// SERVICE AGENT 4: yardServiceHandledBy
{
    title: 'Yard Service-Agent',
    key: 'yardServiceAgent',
    width: 180,
    sorter: (a, b) => {
        const nameA = getYardServiceAgentName(a) || '';
        const nameB = getYardServiceAgentName(b) || '';
        return nameA.localeCompare(nameB);
    },
    render: (_, record) => {
        const agentName = getYardServiceAgentName(record);
        const isAssigned = !!agentName;
        
        return (
            <div style={{ cursor: 'pointer' }} onClick={() => handleServiceAgentEdit(record, 'yardServiceHandledBy')}>
                <Tooltip title={isAssigned ? `Click to change yard service agent` : 'Click to assign yard service agent'}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <Avatar size={32} icon={<TeamOutlined />} style={{ backgroundColor: isAssigned ? '#eb2f96' : '#f0f0f0', flexShrink: 0 }}>
                            {isAssigned && agentName?.[0]?.toUpperCase()}
                        </Avatar>
                        <div style={{ flex: 1 }}>
                            {isAssigned ? (
                                <>
                                    <Text ellipsis={{ tooltip: true }} style={{ fontSize: 13, color: '#1f2937', display: 'block', fontWeight: 500 }}>
                                        {agentName}
                                    </Text>
                                    <Text type="secondary" style={{ fontSize: 10 }}>Click to edit</Text>
                                </>
                            ) : (
                                <Text style={{ fontSize: 13, color: '#1890ff', fontStyle: 'italic' }}>+ Assign Agent</Text>
                            )}
                        </div>
                        <EditOutlined style={{ fontSize: 12, color: '#1890ff', opacity: 0.6 }} />
                    </div>
                </Tooltip>
            </div>
        );
    },
},
    {
  title: 'Order Status',
  key: 'orderStatus',
  width: 200,
  render: (_, record) => {
    const paymentAllow = record.payementAllow || 'No';
    const shipmentPartStatus = record.ShipmentTracking?.partStatus || 'Not Available';
    const orderPartStatus = record.orderProcessComplete?.partStatus || 'N/A';
    
    const getPaymentColor = () => {
      return paymentAllow === 'Yes' ? 'success' : 'error';
    };
    
    const getShipmentPartColor = (status) => {
      switch(status) {
        case 'Available': return '#52c41a';
        case 'Not Available': return '#f5222d';
        case 'Not Good': return '#faad14';
        case 'Wrong Part': return '#f5222d';
        case 'Customer Canceled Order': return '#8c8c8c';
        default: return '#d9d9d9';
      }
    };
    
    const getShipmentPartIcon = (status) => {
      switch(status) {
        case 'Available': return <CheckCircleOutlined />;
        case 'Not Available': return <CloseCircleOutlined />;
        case 'Not Good': return <ExclamationCircleOutlined />;
        case 'Wrong Part': return <CloseCircleOutlined />;
        case 'Customer Canceled Order': return <StopOutlined />;
        default: return null;
      }
    };
    
    const getOrderPartColor = (status) => {
      return status === 'Customer Canceled' ? 'error' : 'success';
    };
    
    return (
      <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 12px' }}>
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {/*  Payment Paid */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Tag 
              color={getPaymentColor()}
              icon={paymentAllow === 'Yes' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
              style={{ margin: 0, fontSize: 11 }}
            >
              {paymentAllow === 'Yes' ? '✅ Approved' : '❌ Not Approved'}
            </Tag>
          </div>
          
          {/* Shipment Part Status */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Tag 
              color={getShipmentPartColor(shipmentPartStatus)}
              icon={getShipmentPartIcon(shipmentPartStatus)}
              style={{ margin: 0, fontSize: 11 }}
            >
              {shipmentPartStatus}
            </Tag>
          </div>
          
          {/* Order Process Part Status */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Tag 
              color={getOrderPartColor(orderPartStatus)}
              icon={orderPartStatus === 'Customer Canceled' ? <StopOutlined /> : <CheckCircleOutlined />}
              style={{ margin: 0, fontSize: 11 }}
            >
              {orderPartStatus === 'Customer Canceled' ? '❌ Customer Canceled' : '✅ Customer Accepted'}
            </Tag>
          </div>
        </Space>
      </Card>
    );
  },
},
    {
      title: 'Customer',
      key: 'customer',
      fixed: 'left',
      width: 320,
      sorter: true,
      sortOrder: sortedInfo.field === 'customer' && sortedInfo.order,
      render: (_, record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Avatar 
            size={44}
            icon={<UserOutlined />} 
            style={{ 
              background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
              boxShadow: '0 4px 12px rgba(24,144,255,0.2)',
              flexShrink: 0
            }}
          />
          <div style={{ flex: 1 }}>
            <Text strong style={{ fontSize: 14, display: 'block', marginBottom: 4 }}>
              {record.personalInfo?.fullName || 'N/A'}
            </Text>
            <Space direction="vertical" size={2}>
              <Space size={4}>
                <MailOutlined style={{ color: '#1890ff', fontSize: 11 }} />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {record.personalInfo?.email || 'N/A'}
                </Text>
              </Space>
              <Space size={4}>
                <PhoneOutlined style={{ color: '#52c41a', fontSize: 11 }} />
                <Text type="secondary" style={{ fontSize: 12 }}>
                  {record.personalInfo?.phoneNumber || 'N/A'}
                </Text>
              </Space>
            </Space>
          </div>
        </div>
      ),
    },
    {
      title: 'Vehicle',
      key: 'vehicleInfo',
      width: 250,
      render: (_, record) => (
        <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 12px' }}>
          <Space direction="vertical" size={4} style={{ width: '100%' }}>
            <Space size={4}>
              <CarOutlined style={{ color: '#faad14', fontSize: 12 }} />
              <Text strong style={{ fontSize: 13 }}>
                {record.vehicleInfo?.year || ''} {record.vehicleInfo?.make || ''}
              </Text>
            </Space>
            <Text type="secondary" style={{ fontSize: 12, marginLeft: 18 }}>
              {record.vehicleInfo?.model || 'N/A'}
            </Text>
            {record.vehicleInfo?.variant && (
              <Tag style={{ marginLeft: 18, marginTop: 2, fontSize: 10 }}>
                {record.vehicleInfo.variant}
              </Tag>
            )}
            <div style={{ marginTop: 6, borderTop: '1px dashed #e8e8e8', paddingTop: 6 }}>
              <Space size={4}>
                <TagOutlined style={{ color: '#1890ff', fontSize: 11 }} />
                <Tag color="cyan" style={{ fontSize: 11 }}>
                  {record.vehicleInfo?.part || 'N/A'}
                </Tag>
              </Space>
            </div>
          </Space>
        </Card>
      ),
    },
         {
    title: 'Specification',
    key: 'specification',
    width: 250,
    render: (_, record) => {
        const specification = record.vehicleInfo?.specification || '';
        const isEditing = editingSpecification === record._id;
        
        if (isEditing) {
            return (
                <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-start' }}>
                    <Input.TextArea
                        autoSize={{ minRows: 2, maxRows: 4 }}
                        value={editingSpecValue}
                        onChange={(e) => setEditingSpecValue(e.target.value)}
                        placeholder="Enter specification details..."
                        style={{ flex: 1, fontSize: '12px' }}
                        autoFocus
                        maxLength={2000}
                        showCount
                    />
                    <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                        <Button
                            size="small"
                            type="primary"
                            icon={<CheckOutlined />}
                            loading={updatingSpecification}
                            onClick={() => handleUpdateSpecification(record._id, editingSpecValue)}
                            style={{ minWidth: '32px' }}
                        />
                        <Button
                            size="small"
                            icon={<CloseOutlined />}
                            onClick={() => {
                                setEditingSpecification(null);
                                setEditingSpecValue('');
                            }}
                        />
                    </div>
                </div>
            );
        }
        
        return (
            <div 
                style={{ 
                    cursor: 'pointer',
                    padding: '8px',
                    borderRadius: '6px',
                    transition: 'all 0.3s',
                    backgroundColor: specification ? 'transparent' : '#fafafa',
                    border: '1px solid transparent',
                    minHeight: '60px'
                }}
                onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#f5f5f5';
                    e.currentTarget.style.borderColor = '#d9d9d9';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = specification ? 'transparent' : '#fafafa';
                    e.currentTarget.style.borderColor = 'transparent';
                }}
                onClick={(e) => {
                    e.stopPropagation();
                    setEditingSpecification(record._id);
                    setEditingSpecValue(specification);
                }}
            >
                {specification ? (
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                            <FileTextOutlined style={{ color: '#52c41a', fontSize: '12px' }} />
                            <Text strong style={{ fontSize: '12px', color: '#52c41a' }}>Specification:</Text>
                        </div>
                        <Text style={{ 
                            fontSize: '12px', 
                            whiteSpace: 'pre-wrap', 
                            wordBreak: 'break-word',
                            display: 'block',
                            lineHeight: '1.5'
                        }}>
                            {specification.length > 100 
                                ? `${specification.substring(0, 100)}...` 
                                : specification}
                        </Text>
                        <div style={{ marginTop: '4px' }}>
                            <Text type="secondary" style={{ fontSize: '10px' }}>
                                <EditOutlined style={{ marginRight: '4px' }} />
                                Click to edit
                            </Text>
                        </div>
                    </div>
                ) : (
                    <div style={{ textAlign: 'center', padding: '12px' }}>
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            <FileTextOutlined style={{ marginRight: '4px', color: '#52c41a' }} />
                            <EditOutlined style={{ marginRight: '4px', fontSize: '10px' }} />
                            Click to add specification
                        </Text>
                    </div>
                )}
            </div>
        );
    },
}, 
   {
  title: 'Refund Info',
  key: 'customerRefund',
  width: 280,
  render: (_, record) => {
    const isEditing = editingCustomerRefundId === record._id;
    const refund = record.customerRefund || {};
    const chargedAmount = refund.customerChargedAmount || record.totalAmount || 0;
    const refundAmount = refund.refundAmount || 0;
    const restockingFee = refund.restockingFee || 0;
    const refundStatus = refund.customerRefundStatus || "No";
    const updatedDate = record.customerRefundUpdatedAt;

    if (isEditing) {
      return (
        <Card size="small" style={{ borderRadius: 10, background: '#fafafa', border: 'none' }} bodyStyle={{ padding: '8px 12px' }}>
          <Space direction="vertical" size={8} style={{ width: "100%" }}>
            {/* Charged Amount Edit */}
            <div>
              <Text style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>Charged Amount ($):</Text>
              <InputNumber
                value={editingCustomerRefundData.customerChargedAmount}
                onChange={(value) => setEditingCustomerRefundData({ ...editingCustomerRefundData, customerChargedAmount: value || 0 })}
                style={{ width: '100%' }}
                size="small"
                min={0}
                step={0.01}
                prefix="$"
              />
            </div>

            {/* Refund Amount Edit */}
            <div>
              <Text style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>Refund Amount ($):</Text>
              <InputNumber
                value={editingCustomerRefundData.refundAmount}
                onChange={(value) => setEditingCustomerRefundData({ ...editingCustomerRefundData, refundAmount: value || 0 })}
                style={{ width: '100%' }}
                size="small"
                min={0}
                step={0.01}
                prefix="$"
              />
            </div>

            {/* Restocking Fee Edit */}
            <div>
              <Text style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>Restocking Fee ($):</Text>
              <InputNumber
                value={editingCustomerRefundData.restockingFee}
                onChange={(value) => setEditingCustomerRefundData({ ...editingCustomerRefundData, restockingFee: value || 0 })}
                style={{ width: '100%' }}
                size="small"
                min={0}
                step={0.01}
                prefix="$"
              />
            </div>

            {/* Refund Status Edit */}
            <div>
              <Text style={{ fontSize: 11, display: 'block', marginBottom: 4 }}>Refund Status:</Text>
              <Select
                value={editingCustomerRefundData.customerRefundStatus}
                onChange={(value) => setEditingCustomerRefundData({ ...editingCustomerRefundData, customerRefundStatus: value })}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value="Yes">Yes (Refunded)</Option>
                <Option value="No">No (Not Refunded)</Option>
              </Select>
            </div>

            {/* Action Buttons */}
            <Space size={8} style={{ width: '100%', justifyContent: 'flex-end' }}>
              <Button size="small" onClick={handleEditCustomerRefundCancel} disabled={savingCustomerRefund}>
                Cancel
              </Button>
              <Button type="primary" size="small" onClick={() => handleEditCustomerRefundSave(record)} loading={savingCustomerRefund}>
                Save
              </Button>
            </Space>
          </Space>
        </Card>
      );
    }

    return (
      <Card 
        size="small" 
        style={{ borderRadius: 10, background: '#fafafa', border: 'none', position: 'relative' }} 
        bodyStyle={{ padding: '8px 12px' }}
      >
        {/* Edit Icon */}
        <Tooltip title="Edit Refund Info">
          <Button
            type="text"
            size="small"
            icon={<EditOutlined />}
            onClick={() => handleEditCustomerRefundStart(record)}
            style={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: '#1890ff',
              zIndex: 1
            }}
          />
        </Tooltip>

        <Space direction="vertical" size={6} style={{ width: "100%" }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space size={4}>
              <DollarOutlined style={{ color: '#1890ff', fontSize: 12 }} />
              <Text style={{ fontSize: 12 }}>Charged:</Text>
            </Space>
            <Text strong style={{ fontSize: 13, color: '#1890ff' }}>
              ${chargedAmount.toFixed(2)}
            </Text>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space size={4}>
              <ReloadOutlined style={{ color: '#52c41a', fontSize: 12 }} />
              <Text style={{ fontSize: 12 }}>Refund:</Text>
            </Space>
            <Text strong style={{ fontSize: 13, color: '#52c41a' }}>
              ${refundAmount.toFixed(2)}
            </Text>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space size={4}>
              <PercentageOutlined style={{ color: '#faad14', fontSize: 12 }} />
              <Text style={{ fontSize: 12 }}>Restocking:</Text>
            </Space>
            <Text strong style={{ fontSize: 13, color: '#faad14' }}>
              ${restockingFee.toFixed(2)}
            </Text>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Space size={4}>
              <CheckOutlined style={{ color: refundStatus === "Yes" ? '#52c41a' : '#ff4d4f', fontSize: 12 }} />
              <Text style={{ fontSize: 12 }}>Status:</Text>
            </Space>
            <Tag 
              color={refundStatus === "Yes" ? "success" : "error"}
              style={{ borderRadius: 12, padding: '2px 10px' }}
            >
              {refundStatus === "Yes" ? "Refunded" : "Not Refunded"}
            </Tag>
          </div>

          {updatedDate && (
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Space size={4}>
                <CalendarOutlined style={{ color: '#13c2c2', fontSize: 12 }} />
                <Text style={{ fontSize: 12 }}>Updated:</Text>
              </Space>
              <Text type="secondary" style={{ fontSize: 11 }}>
                {dayjs(updatedDate).format("MMM DD, YYYY")}
              </Text>
            </div>
          )}
        </Space>
      </Card>
    );
  },
},

  {
    title: 'Date Info',
    key: 'dateInfo',
    width: 200,
    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    render: (_, record) => (
        <Tooltip
            title={
                <>
                    <div><strong>Created:</strong> {record.createdAt ? dayjs(record.createdAt).format('MM-DD-YYYY hh:mm A') : 'N/A'}</div>
                    <div><strong>Updated:</strong> {record.updatedAt ? dayjs(record.updatedAt).format('MM-DD-YYYY hh:mm A') : 'N/A'}</div>
                </>
            }
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>

                {/* Created */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: '#F1EFE8',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <ClockCircleOutlined style={{ fontSize: 13, color: '#888780' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2 }}>
                            {record.createdAt ? dayjs(record.createdAt).format('MM/DD/YY · hh:mm A') : 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                            Created · {record.createdAt ? dayjs(record.createdAt).fromNow() : '—'}
                        </Text>
                    </div>
                </div>

                {/* Updated */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <div style={{
                        width: 28, height: 28, borderRadius: 8,
                        background: '#E6F1FB',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0,
                    }}>
                        <SyncOutlined style={{ fontSize: 13, color: '#185FA5' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Text style={{ fontSize: 12, fontWeight: 500, lineHeight: 1.2, color: '#185FA5' }}>
                            {record.updatedAt ? dayjs(record.updatedAt).format('MM/DD/YY · hh:mm A') : 'N/A'}
                        </Text>
                        <Text type="secondary" style={{ fontSize: 11, lineHeight: 1.2 }}>
                            Updated · {record.updatedAt ? dayjs(record.updatedAt).fromNow() : '—'}
                        </Text>
                    </div>
                </div>

            </div>
        </Tooltip>
    ),
},
     {
             title: 'Comment',
             key: 'customerRefundPageComment',
             width: 280,
             render: (_, record) => {
                 const comments = record.customerRefundPageComment || [];
                 const latestComment = comments.length > 0 ? comments[comments.length - 1] : null;
                 
                 return (
                     <div>
                      
         
                         {/* Display Latest Comment */}
                         {latestComment ? (
                             <div 
                                 style={{
                                     background: '#fafafa',
                                     padding: '8px 10px',
                                     borderRadius: '8px',
                                     border: '1px solid #f0f0f0',
                                     cursor: 'pointer',
                                     transition: 'all 0.3s ease',
                                     wordBreak: 'break-word',      // Add this
                                     wordWrap: 'break-word',       // Add this
                                     overflowWrap: 'break-word',   // Add this
                                     whiteSpace: 'normal'          // Add this
                                 }}
                                 onClick={(e) => {
                                     e.stopPropagation();
                                     setSelectedLeadForComment(record);
                                     setCommentsModalVisible(true);
                                 }}
                             >
                                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                                     <Text type="secondary" style={{ fontSize: '10px' }}>
                                         <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                         {formatCommentDate(latestComment.changedAt)}
                                     </Text>
                                     {comments.length > 1 && (
                                         <Tag 
                                             color="blue" 
                                             style={{ 
                                                 fontSize: '10px', 
                                                 padding: '0 4px', 
                                                 margin: 0,
                                                 cursor: 'pointer'
                                             }}
                                             onClick={(e) => {
                                                 e.stopPropagation();
                                                 setSelectedLeadForComment(record);
                                                 setCommentsModalVisible(true);
                                             }}
                                         >
                                             +{comments.length - 1} more
                                         </Tag>
                                     )}
                                 </div>
                                 <Text style={{ 
                                     fontSize: '12px', 
                                     display: 'block', 
                                     wordBreak: 'break-word',    // Add this
                                     whiteSpace: 'pre-wrap'       // Add this for preserving whitespace and wrapping
                                 }}>
                                     {latestComment.comment.length > 80 
                                         ? `${latestComment.comment.substring(0, 80)}...` 
                                         : latestComment.comment}
                                 </Text>
                             </div>
                         ) : (
                             <div 
                                 style={{ 
                                     textAlign: 'center', 
                                     padding: '12px',
                                     background: '#fafafa',
                                     borderRadius: '8px',
                                     border: '1px solid #f0f0f0',
                                     cursor: 'pointer'
                                 }}
                                 onClick={(e) => {
                                     e.stopPropagation();
                                     setSelectedLeadForComment(record);
                                     setCommentsModalVisible(true);
                                 }}
                             >
                                 <Text type="secondary" style={{ fontSize: '12px' }}>
                                     <CommentOutlined style={{ marginRight: '4px', fontSize: '14px' }} />
                                     No comments yet
                                 </Text>
                             </div>
                         )}
                            <Button
                             type="primary"
                             size="small"
                             icon={<CommentOutlined />}
                             onClick={(e) => {
                                 e.stopPropagation();
                                 setSelectedLeadForComment(record);
                                 setNewComment('');
                                 setCommentsModalVisible(true);
                             }}
                             style={{ 
                                 marginBottom: '12px',
                                 width: '100%',
                                 fontSize: '12px'
                             }}
                         >
                             Add Comment
                         </Button>
                     </div>
                 );
             },
         },
    {
      title: '',
      key: 'actions',
      width: 60,
      fixed: 'right',
      align: 'center',
      render: (_, record) => (
        <Tooltip title="View Lead Details">
          <Button 
            type="primary"
            shape="circle"
            icon={<EyeOutlined />} 
            onClick={() => handleView(record)}
            style={{ 
              background: `linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)`,
              border: 'none',
              boxShadow: '0 2px 8px rgba(24,144,255,0.3)',
              width: 32,
              height: 32
            }}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div style={{ 
      padding: 24, 
      minHeight: "100vh", 
      background: `linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)`
    }}>
      {/* Modern Header with Stats */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Card 
          style={{ 
            marginBottom: 24, 
            borderRadius: 24,
            border: 'none'
          }}
          bodyStyle={{ padding: '32px' }}
        >
          <Row gutter={[24, 24]} align="middle">
            <Col xs={24} md={12}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                <Avatar 
                  size={72} 
                  style={{ 
                    background: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                    color:"black"
                  }}
                  icon={<ReloadOutlined style={{ fontSize: 36 }} />}
                />
                <div>
                  <Title level={2} style={{ margin: 0, fontWeight: 700 }}>
                    Customer Refund
                  </Title>
                  <Text style={{ fontSize: 14 }}>
                    Manage and track customer refund requests
                  </Text>
                </div>
              </div>
            </Col>
    
          </Row>
        </Card>
      </motion.div>

      {/* Filter Section */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        <Card 
          bordered={false}
          style={{ 
            borderRadius: 20,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
            marginBottom: 24,
            border: '1px solid #f0f0f0'
          }}
          bodyStyle={{ padding: '20px 24px' }}
        >
          <Row gutter={[16, 16]} align="middle">
            <Col xs={24} md={8}>
              <Space.Compact block>
                <SearchFieldsSelect value={searchFields} onChange={setSearchFields} />
                <Input
                  placeholder={getSearchFieldsPlaceholder(searchFields)}
                  prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                  value={searchText}
                  onChange={(e) => handleSearch(e.target.value)}
                  allowClear
                  size="large"
                />
              </Space.Compact>
            </Col>
            {isAdmin && (
              <Col xs={24} md={4}>
                <Select
                  placeholder="Filter by Agent"
                  value={selectedAgentId}
                  onChange={setSelectedAgentId}
                  style={{ width: '100%', borderRadius: 12 }}
                  size="large"
                  allowClear
                  suffixIcon={<TeamOutlined />}
                  showSearch
                  optionFilterProp="children"
                >
                  {agents.map(agent => (
                    <Option key={agent._id} value={agent._id}>
                      <Space>
                        <Avatar size="small" icon={<UserOutlined />} />
                        <span>{agent.firstName} {agent.lastName}</span>
                      </Space>
                    </Option>
                  ))}
                </Select>
              </Col>
            )}
            <Col xs={24} md={4}>
              <Select
                placeholder="Quick Date"
                style={{ width: '100%', borderRadius: 12 }}
                onChange={handleQuickDateFilter}
                value={quickDateFilter}
                size="large"
              >
                <Option value="today">Today</Option>
                <Option value="yesterday">Yesterday</Option>
                <Option value="thisWeek">This Week</Option>
                <Option value="thisMonth">This Month</Option>
                <Option value="lastMonth">Last Month</Option>
                <Option value="thisQuarter">This Quarter</Option>
                <Option value="thisYear">This Year</Option>
                <Option value="custom">Custom Range</Option>
              </Select>
            </Col>
            <Col xs={24} md={isAdmin ? 7 : 8}>
              <RangePicker
                style={{ width: '100%', borderRadius: 12 }}
                onChange={handleDateRangeChange}
                value={dateRange}
                size="large"
                  allowClear={{ clearIcon: <CloseOutlined /> }}

                placeholder={['Start Date', 'End Date']}
              />
            </Col>
            <Col xs={24} md={isAdmin ? 4 : 6}>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Tooltip title="Refresh">
                  <Button 
                    icon={<ReloadOutlined />} 
                    onClick={handleRefresh}
                    loading={refreshing}
                    size="large"
                    style={{ borderRadius: 12 }}
                  />
                </Tooltip>
                <Tooltip title="Clear Filters">
                  <Button 
                    icon={<ClearOutlined />} 
                    onClick={clearAllFilters}
                    size="large"
                    style={{ borderRadius: 12 }}
                  />
                </Tooltip>
              </Space>
            </Col>
          </Row>

       {/* Date Range Info - Add null check */}
{dateRange && dateRange[0] && dateRange[1] && (
  <div style={{ 
    marginTop: 16,
    backgroundColor: '#f0f5ff', 
    padding: '8px 12px', 
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    gap: 8
  }}>
    <CalendarOutlined style={{ color: '#1890ff' }} />
    <Text type="secondary">
      Showing refund orders from: <Text strong>{dateRange[0].format('MM-DD-YYYY')}</Text> to <Text strong>{dateRange[1].format('MM-DD-YYYY')}</Text>
    </Text>
    <Badge 
      count={totalRecords} 
      showZero 
      color="#52c41a" 
      style={{ marginLeft: 'auto' }}
    />
  </div>
)}
        </Card>
      </motion.div>

    {/* Results Header - Update the date display section */}
<div style={{
  padding: '16px 20px',
  background: '#ffffff',
  borderTop: '1px solid #f0f0f0',
  borderBottom: '1px solid #f0f0f0',
  borderRadius: '12px 12px 0 0',
  marginTop: 8
}}>
  <Row justify="space-between" align="middle">
    <Col>
      <Space size={16}>
        <Text strong style={{ fontSize: 16 }}>
          {isSearching ? (
            <>
              <SearchOutlined style={{ color: '#1890ff', marginRight: 8 }} />
              Search Results
            </>
          ) : (
            <>
              <CalendarOutlined style={{ marginRight: 8, color: '#1890ff' }} />
              {dateRange && dateRange[0] && dateRange[1] ? (
                dateRange[0].isSame(dateRange[1], 'day') ? (
                  dateRange[0].format('MM-DD-YYYY')
                ) : (
                  `${dateRange[0].format('MMM D')} → ${dateRange[1].format('MM-DD-YYYY')}`
                )
              ) : "Today"}
            </>
          )}
        </Text>
        <Badge
          count={leads.length}
          showZero
          style={{
            backgroundColor: '#52c41a',
            fontSize: 12,
            fontWeight: 'bold'
          }}
        />
        <Text type="secondary">
          of {totalRecords.toLocaleString()} total records
        </Text>
      </Space>
    </Col>
    <Col>
      <Pagination
        current={currentPage}
        pageSize={pageSize}
        total={totalRecords}
        showSizeChanger
        pageSizeOptions={["10", "20", "50", "100"]}
        onChange={handlePaginationChange}
        size="small"
        simple
        showTotal={(total, range) => `${range[0]}-${range[1]} of ${total}`}
      />
    </Col>
  </Row>
</div>

      {/* Main Table */}
      <Card 
        bordered={false}
        style={{ 
          borderRadius: '0 0 20px 20px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
          overflow: 'hidden',
          borderTop: 'none'
        }}
        bodyStyle={{ padding: 0 }}
      >
        <Table
          columns={columns}
          dataSource={leads}
          rowKey="_id"
          loading={loading}
          pagination={false}
          onChange={handleTableChange}
          scroll={{ x: isAdmin ? 1700 : 1500, y: 'calc(100vh - 550px)' }}
          bordered={false}
          size="middle"
          rowClassName={() => 'table-row-hover'}
          style={{
            background: 'transparent'
          }}
        />

        {/* Bottom Pagination */}
        {leads.length > 0 && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 32,
            padding: '20px 24px',
            background: '#fafafa',
            borderRadius: 12,
            margin: 24
          }}>
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalRecords}
              showSizeChanger
              pageSizeOptions={["10", "20", "50", "100"]}
              onChange={handlePaginationChange}
              showQuickJumper
              showTotal={(total, range) =>
                `Showing ${range[0]}-${range[1]} of ${total} refund orders`
              }
              size="default"
            />
          </div>
        )}
      </Card>

      <style>{`
        .table-row-hover:hover {
          background: linear-gradient(90deg, #f0f7ff 0%, #ffffff 100%) !important;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        
        .ant-table-tbody > tr > td {
          border-bottom: 1px solid #f0f0f0 !important;
        }
        
        .ant-table-thead > tr > th {
          background: #fafafa !important;
          font-weight: 600 !important;
          font-size: 13px !important;
          color: #1f2937 !important;
          border-bottom: 2px solid #f0f0f0 !important;
        }
      `}</style>

       <Modal
               
                open={commentsModalVisible}
                onCancel={() => {
                    setCommentsModalVisible(false);
                    setSelectedLeadForComment(null);
                    setNewComment('');
                }}
                footer={[
                    <Button key="cancel" onClick={() => {
                        setCommentsModalVisible(false);
                        setSelectedLeadForComment(null);
                        setNewComment('');
                    }}>
                        Cancel
                    </Button>,
                    <Button 
                        key="submit" 
                        type="primary" 
                        onClick={handleAddComment}
                        loading={addingComment}
                        disabled={!newComment.trim()}
                    >
                        Add Comment
                    </Button>
                ]}
                width={500}
            >
                <div style={{ padding: '16px 0' }}>
                  
            
                    <div>
                        <Text strong>Comment:</Text>
                        <Input.TextArea
                            placeholder="Enter your comment here..."
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            rows={4}
                            maxLength={1000}
                            showCount
                            style={{ marginTop: '8px' }}
                            autoFocus
                        />
                    </div>
            
                    {/* Show existing comments if any */}
                    {selectedLeadForComment?.customerRefundPageComment?.length > 0 && (
                        <div style={{ marginTop: '20px' }}>
                            <Divider />
                            <Text strong>Previous Comments ({selectedLeadForComment.customerRefundPageComment.length})</Text>
                            <div style={{ 
                                maxHeight: '200px', 
                                overflowY: 'auto', 
                                marginTop: '8px',
                                padding: '8px',
                                background: '#f5f5f5',
                                borderRadius: '8px'
                            }}>
                                {[...selectedLeadForComment.customerRefundPageComment]
                                    .sort((a, b) => new Date(b.changedAt) - new Date(a.changedAt))
                                    .map((comment, idx) => (
                                        <div key={idx} style={{ 
                                            marginBottom: '12px', 
                                            padding: '8px',
                                            background: 'white',
                                            borderRadius: '6px',
                                            border: '1px solid #e8e8e8'
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                                                <Text type="secondary" style={{ fontSize: '11px' }}>
                                                    <ClockCircleOutlined style={{ marginRight: '4px' }} />
                                                    {formatCommentDate(comment.changedAt)}
                                                </Text>
                                            </div>
                                            <Text style={{ fontSize: '13px' }}>{comment.comment}</Text>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
{/* Service Agent Assignment Modal */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                width: 40,
                height: 40,
                borderRadius: 12,
                background: 'linear-gradient(135deg, #52c41a 0%, #73d13d 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <TeamOutlined style={{ fontSize: 20, color: 'white' }} />
            </div>
            <div>
                <Title level={4} style={{ margin: 0 }}>Assign Service Agent</Title>
                <Text type="secondary" style={{ fontSize: 12 }}>
                    Select service agent for this lead
                </Text>
            </div>
        </div>
    }
    open={serviceAgentModalVisible}
    onCancel={() => {
        setServiceAgentModalVisible(false);
        setSelectedLeadForServiceAgent(null);
        setSelectedServiceAgentForLead(null);
    }}
    footer={null}
    width={500}
    centered
>
    <div style={{ padding: '16px 0' }}>
        {selectedLeadForServiceAgent && (
            <>
                <Card size="small" style={{ marginBottom: 20, background: '#f5f5f5', borderRadius: 12, border: 'none' }} bodyStyle={{ padding: '12px 16px' }}>
                    <Space direction="vertical" size={4} style={{ width: '100%' }}>
                        <Text strong>{selectedLeadForServiceAgent.personalInfo?.fullName || 'N/A'}</Text>
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            {selectedLeadForServiceAgent.vehicleInfo?.make} {selectedLeadForServiceAgent.vehicleInfo?.model} - {selectedLeadForServiceAgent.vehicleInfo?.part}
                        </Text>
                    </Space>
                </Card>

                <div style={{ marginBottom: 24 }}>
                    <Text strong style={{ display: 'block', marginBottom: 8 }}>Select Service Agent:</Text>
                    <Select
                        value={selectedServiceAgentForLead}
                        onChange={setSelectedServiceAgentForLead}
                        style={{ width: '100%' }}
                        size="large"
                        placeholder="Choose an agent"
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        loading={loadingServiceAgents}
                    >
                        {Object.entries(serviceAgentsMap).map(([agentId, agentInfo]) => (
                            <Option key={agentId} value={agentId}>
                                <Space direction="vertical" size={0}>
                                    <Text strong>{agentInfo.name}</Text>
                                    <Text type="secondary" style={{ fontSize: 11 }}>{agentInfo.role}</Text>
                                </Space>
                            </Option>
                        ))}
                    </Select>
                </div>

                <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                    <Button onClick={() => {
                        setServiceAgentModalVisible(false);
                        setSelectedLeadForServiceAgent(null);
                        setSelectedServiceAgentForLead(null);
                    }} size="large">Cancel</Button>
                    <Button type="primary" onClick={() => handleServiceAgentSave(selectedServiceAgentField)} loading={savingServiceAgent} size="large" icon={<CheckOutlined />}>
                        {selectedServiceAgentForLead ? 'Assign Agent' : 'Unassign Agent'}
                    </Button>
                </div>
            </>
        )}
    </div>
</Modal>
    </div>
  );
};

export default CustomerRefund;
